import { Button, IButtonProps, Icon, IconSvg, IIconProps, Size, Tooltip } from '@busybusy/webapp-react-ui';
import { InfoIcon } from 'assets/icons';
import classNames from 'classnames';

export interface IIconButtonProps extends Omit<IButtonProps, 'tag' | 'type'> {
  tooltipLabel?: string;
  buttonSize?: Size;
  iconTheme?: IIconProps['theme'];
  svg?: IconSvg;
}

const IconButton = ({
  className,
  svg = InfoIcon,
  size = Size.MEDIUM,
  value = '',
  rounded = false,
  shadow = false,
  fullWidth = false,
  disabled = false,
  ripple = false,
  tabIndex = 0,
  buttonSize = Size.MEDIUM,
  tooltipLabel,
  iconTheme,
  ...buttonProps
}: IIconButtonProps) => {
  function renderButton() {
    return (
      <Button
        className={classNames('icon-button', className)}
        type={'icon'}
        size={buttonSize}
        value={value}
        rounded={rounded}
        shadow={shadow}
        fullWidth={fullWidth}
        disabled={disabled}
        ripple={ripple}
        tabIndex={tabIndex}
        {...buttonProps}
      >
        <Icon svg={svg} size={size} theme={iconTheme} />
      </Button>
    );
  }

  return <>{tooltipLabel ? <Tooltip label={tooltipLabel}>{renderButton()}</Tooltip> : renderButton()}</>;
};

export default IconButton;
